import { api } from "./client";

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

// create api
export const createVariantAttribute = async (payload) => {
  try {
    const response = await api.post(`${API_BASE_URL}api/variant/variant-attributes`, payload, {
      headers: {
        "Content-Type": "application/json",
        "Accept-Language": localStorage.getItem("lang") || "en",
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    });
    return response.data;
  } catch (error) {
    throw error.response?.data || { message: "Failed to create variant attribute" };
  }
};

// get api
export const getAllVariantAttributes = async () => {
  const lang = localStorage.getItem("lang") || "en";
  const response = await api.get(`${API_BASE_URL}api/variant/variant-attributes`, {
    headers: { "Accept-Language": lang },
  });
  return response.data;
};

// Update api
export const updateVariantAttribute = async (id, data) => {
  try {
    const response = await api.put(`${API_BASE_URL}api/variant/variant-attributes/${id}`, data);
    return response.data;
  } catch (error) {
    // Log the full error for debugging
    console.error("Failed to update variant attribute:", error);

    // Re-throw a clean message to be caught by your component
    throw new Error(
      error?.response?.data?.message || "Failed to update variant attribute"
    );
  }
};

//Delete api
export const deleteVariantAttribute = async (id) => {
  try {
    const res = await api.delete(`${API_BASE_URL}api/variant/variant-attributes/${id}`);
    return res.data;
  } catch (error) {
    throw new Error(
      error.response?.data?.message || "Failed to delete variant attribute"
    );
  }
};